export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10675.2456ede4.jpg";